import React from 'react';

interface TrendCardProps {
    trend: {
        name: string;
        value: string;
        change: string;
        changeType: 'up' | 'down';
    };
    onClick?: () => void;
}

const TrendCard: React.FC<TrendCardProps> = ({trend, onClick}) => {
    const {name, value, changeType} = trend;
    const isUp = changeType === 'up';

    // Split the name into two parts if it contains a space
    const nameParts = name.split(' ');
    const firstPart = nameParts[0];
    const secondPart = nameParts.slice(1).join(' ');

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick?.();
        }
    };

    return (
        <div
            className="bg-mld-panel-bg rounded-full border border-mld-panel-border px-4 py-3 flex items-center w-full md:w-[220px] lg:w-[240px] flex-shrink-0 transition-all duration-200 touch-manipulation cursor-pointer hover:bg-white hover:shadow-sm"
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={handleKeyDown}>
            <div className="flex items-center mr-4">
                <span className="text-2xl font-semibold mr-2 text-mld-lab-trend">{isUp ? '↗' : '↘'}</span>
                <span className="text-2xl font-semibold text-mld-lab-trend">{value}</span>
            </div>
            <div className="text-left">
                <div className="text-sm font-medium text-mld-card-text leading-tight">{firstPart}</div>
                {secondPart && <div className="text-sm font-medium text-mld-card-text leading-tight">{secondPart}</div>}
            </div>
        </div>
    );
};

export default TrendCard;
